import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { StepModel } from '../../models/step.model';

@Component({
  selector: 'hazmatsuite-next-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent {
  @Input() steps: StepModel<unknown>[] = [];
  @Input() async = true;
  @Output() selectStep = new EventEmitter<number>();
}
